<div class="outer-content">
  <div class="modal card-background-copy" id="modal-dialog" tabindex="-1">
    <form [formGroup]="yourDependantDetailForm" autocomplete="off" role="form" class=" ">
      <div class="float-left bg-white wd-total">

        <app-content-top-nav [parentElement]="el" [parentFormToValidate]="yourDependantDetailForm" [visibleBackNav]='true' [enableBackNav]='true'
          (onBackClickHandler)="onBackClick()"></app-content-top-nav>
        <!-- Introduction Section Starts -->
        <div class="col-md-12 clear-all title-wrapper">
          <h1 class="responsive-text-8" id="your-dependant-details-header">{{contentData.header}} </h1>
        </div>
        <div class="col-md-12 clear-all content-wrapper">
          <p class="content-top introduction" id="dependant-introduction">
            {{contentData.introduction}}
          </p>
          <div class="info-for-para-text">
            <app-tool-tip-notification [childId]="'your-dependant-nominate'" 
            [tooltipData]="yourDependantConfig"
            (onDisplayMobileTooltipEmitter)="displayTooltipMessage('depNoteConfig')">
            </app-tool-tip-notification>
          </div>
          <div class="col-md-12 bg-lightblue">
            <p class="inner-content-data" id="dependant-noteStatement">{{contentData.noteStatement}}</p>
          </div>
        </div>

        <!-- Introduction Section Ends -->

        <!-- Title Section Starts -->
        <div class="col-md-12 wrapperMargin content-wrapper ">

          <div class="col-md-5 clear-all dep-drp-width">
            <app-dropdown [dropdownConfig]="titleConfig" [pageName]="'your-dependant-details'" [controlName]="'title'" [parent]="yourDependantDetailForm"
              (onChangeHandler)="detectChange()">
            </app-dropdown>
          </div>
          <div class="col-md-12 clear-all margin-top-30 form-field row" *ngIf="enableOtherTitle">
            <div class="form-field col-md-5 clear-all" [ngClass]="{'has-error': yourDependantDetailForm.get('otherTitle').touched
        && yourDependantDetailForm.get('otherTitle').errors}">
              <div class="dropdown-control">
                <label id="othTitle" class="form-label"> {{contentData.otherTitle }}</label>

              </div>
              <div class="form-field-select">
                <select id="your-dependant-details-otherTitle" formControlName="otherTitle" class="form-control some" aria-invalid="false"
                  [ngModel]="yourDependantDetails && yourDependantDetails.otherTitle ? yourDependantDetails.otherTitle : null">

                  <option [disabled]="false" [ngValue]="null">Please select</option>
                  <option *ngFor="let otherTitle of otherTitleList" [value]="otherTitle.description">
                    {{otherTitle.description}}</option>
                </select>
                <i class="icon icon-chevron-down" aria-hidden="true"></i>
              </div>

              <div class="form-validation-error" *ngIf="yourDependantDetailForm.get('otherTitle').touched
                              && yourDependantDetailForm.get('otherTitle').errors 
                              && yourDependantDetailForm.get('otherTitle').hasError('required')">
                <i class="icon icon-error" aria-hidden="true"></i>
                <p>Please select other title</p>
              </div>
            </div>
          </div>
        </div>
        <!-- Title Section Ends -->

        <!-- FirstName & SurName Section Starts -->
        <div class="col-md-12 clear-all content-wrapper margin-left-1 text-box-width">
          <div class="col-md-5 input-wrapper margin-tab row">
            <app-nametext-input [pageName]="'your-dependant-details'" [controllerData]="forenameTextCodeConfig" [parent]="yourDependantDetailForm"
              formControlName="forename" [controlName]="'forename'">
            </app-nametext-input>
          </div>
          <div class="col-md-2 clear-all margin-top-tooltip">
            <app-tool-tip-notification [childId]="'firstNameToolTipInfoCodeConfig'" 
            [tooltipData]="firstNameToolTipInfoCodeConfig"
            (onDisplayMobileTooltipEmitter)="displayTooltipMessage('firstnameConfig')"
            ></app-tool-tip-notification>
          </div>

          <div class="col-md-5 margin-right margin-tab row">
            <app-nametext-input [pageName]="'your-dependant-details'" [controllerData]="middleNameTextCodeConfig" [parent]="yourDependantDetailForm"
              formControlName="middleName" [controlName]="'middleName'">
            </app-nametext-input>
          </div>

          <div class="col-md-5 margin-tab row">
            <app-nametext-input [pageName]="'your-dependant-details'" [controllerData]="surnameTextCodeConfig" [parent]="yourDependantDetailForm"
              formControlName="surname" [controlName]="'surname'">
            </app-nametext-input>
          </div>
        </div>

        <app-modal *ngIf="displayTooltipAlert" [modalConfig]="tooltipModalConfig" (closeModal)="closeTooltipModal()"
        (primaryBtnClick)="alertTooltipPrimaryBtnClick($event)" (secondaryBtnClick)="alertSecondaryBtnClick()"
        [tooltipFlag]="true"></app-modal>

        <!-- DOB Section Starts -->
        <div class="row">
          <div class="col-md-12 content-wrapper margin-top-30">
            <p class="question-font">Date of birth</p>
          </div>
          <div class="col-md-12 margin-left-values">
            <p class="text-color values-font">{{dateOfBirthData}}</p>
          </div>
        </div>
        <!-- DOB Section Ends -->

        <!-- Gender Section Starts -->
         <div class="row">
          <div class="col-md-12 content-wrapper margin-top-30">
            <p class="question-font">Gender</p>
          </div>
          <div class="col-md-12 margin-left-values">
            <p class="text-color values-font">{{genderData}}</p>
          </div>
         </div>
        
        <!-- Gender Section Ends -->

        <!-- MaritalStatus Section Starts -->
        <div class="col-md-12 clear-all margin-top-30 content-padding margin-marital-status">
          <div class="col-md-6 clear-all">
            <app-dropdown [dropdownConfig]="maritalStatusOptions" [pageName]="'dependant-details'" [controlName]="'maritalStatus'" [parent]="yourDependantDetailForm">
            </app-dropdown>
          </div>
        </div>
        <!-- MaritalStatus Section Ends -->

        <!-- RelationToYou Section Starts -->
        <div class="col-md-12 margin-top-30 row margin-left-18">
          <p class="question-font">Relationship to you</p>
        </div>
        <div class="col-md-12 margin-left-18">
          <p class="text-color values-font">{{relationShipData}}</p>
        </div>
        <!-- RelationToYou Section Ends -->

        <div class="col-md-12 underline margin-top">
        </div>

        <div class="col-md-12 clear-all bottom-container">
          <div class="float-left">
            <app-save [parentElement]="el" [parentFormToValidate]="yourDependantDetailForm" [location]="'contentBottom'"></app-save>
          </div>
          <div class="float-right">
            <app-content-bottom-nav (onNextHandler)="gotoNext()" [userInputDetail]="afterApplyDetail['buttonConfig']" [buttonType]="'normalCTA'"></app-content-bottom-nav>
          </div>
        </div>

      </div>
    </form>

  </div>
</div>